import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './ImageGallery.css';

const images = [
  { src: 'https://picsum.photos/800/600?random=1', caption: 'Image 1' },
  { src: 'https://picsum.photos/800/600?random=2', caption: 'Image 2' },
  { src: 'https://picsum.photos/800/600?random=3', caption: 'Image 3' },
  { src: 'https://picsum.photos/800/600?random=4', caption: 'Image 4' },
  { src: 'https://picsum.photos/800/600?random=5', caption: 'Image 5' },
  { src: 'https://picsum.photos/800/600?random=6', caption: 'Image 6' },
  { src: 'https://picsum.photos/800/600?random=7', caption: 'Image 7' },
  { src: 'https://picsum.photos/800/600?random=8', caption: 'Image 8' },
];

const ImageGallery = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (isModalOpen) {
      const handleKeyDown = (event) => {
        if (event.key === 'ArrowRight') {
          nextImage();
        } else if (event.key === 'ArrowLeft') {
          prevImage();
        } else if (event.key === 'Escape') {
          closeModal();
        }
      };
      window.addEventListener('keydown', handleKeyDown);
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [isModalOpen]);

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div className="image-gallery">
      <div className="images">
        {images.map((image, index) => (
          <div className="image-container" key={index} onClick={() => openModal(index)}>
            <img style={{borderRadius :'10px'}} src={image.src} alt={image.caption} />
            <p>{image.caption}</p>
          </div>
        ))}
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="modal"
        overlayClassName="overlay"
      >
        <div className="modal-content">
          <button className="close-button" onClick={closeModal}>×</button>
          <img style={{borderRadius :'10px'}} src={images[currentImageIndex].src} alt={images[currentImageIndex].caption} />
          <p style={{color:'#FFFFFF'}}>{images[currentImageIndex].caption}</p>
          <button className="prev-button" onClick={prevImage}>‹</button>
          <button className="next-button" onClick={nextImage}>›</button>
        </div>
      </Modal>
    </div>
  );
};

export default ImageGallery;
